// =====================================================================
// COSMETICA BEAUTY AWARDS 2027 — CONTENU FRANÇAIS
// Tous les textes du site sont ici. Pour ajouter l'anglais / l'arabe :
// dupliquer ce fichier (content.en.js / content.ar.js) et l'enregistrer
// dans src/content/index.js — aucun composant à modifier.
// =====================================================================

const content = {
  lang: "fr",

  site: {
    name: "COSMETICA BEAUTY AWARDS",
    year: "2027",
    // Ouverture des candidatures (heure d'Alger, UTC+1). Le basculement /candidater est automatique.
    openingDate: "2026-11-10T00:00:00+01:00",
    applyUrl: "https://awards.cosmeticaafrica.com",
    applyDomain: "awards.cosmeticaafrica.com",
  },

  seo: {
    home: {
      title: "COSMETICA BEAUTY AWARDS 2027 — Célébrons l'excellence beauté",
      description:
        "Les COSMETICA BEAUTY AWARDS célèbrent les produits et les marques qui se distinguent par leur qualité, leur créativité, leur innovation. Édition 2027 : candidatures bientôt ouvertes.",
    },
    categories: {
      title: "Les catégories 2027 — COSMETICA BEAUTY AWARDS",
      description: "15 catégories couvrant les principaux univers de la beauté, du Best Skincare Product au COSMETICA Beauty Product of the Year.",
    },
    finalists: {
      title: "Finalistes — COSMETICA BEAUTY AWARDS 2027",
      description: "Annonce des finalistes prévue le 15 mars 2027.",
    },
    winners: {
      title: "Gagnants — COSMETICA BEAUTY AWARDS 2027",
      description: "Les gagnants seront dévoilés fin avril 2027 lors de la cérémonie officielle.",
    },
    apply: {
      title: "Candidater — COSMETICA BEAUTY AWARDS 2027",
      description: "Les candidatures seront bientôt ouvertes. Soyez prévenu de l'ouverture le 10 novembre 2026.",
    },
    contact: {
      title: "Contact — COSMETICA BEAUTY AWARDS 2027",
      description: "Contactez l'équipe des COSMETICA BEAUTY AWARDS.",
    },
  },

  a11y: {
    home: "COSMETICA BEAUTY AWARDS — Accueil",
    mainNav: "Navigation principale",
    mobileNav: "Navigation mobile",
    language: "Langue",
  },

  nav: {
    items: [
      { label: "Les Awards", hash: "essence" },
      { label: "Catégories", to: "/categories" },
      { label: "Le parcours", hash: "parcours" },
      { label: "Dates clés", hash: "dates" },
      { label: "Jury", hash: "jury" },
      { label: "Critères", hash: "criteres" },
      { label: "Finalistes", to: "/finalistes" },
      { label: "Gagnants", to: "/gagnants" },
    ],
    cta: { label: "Candidater", to: "/candidater" },
    tabs: [
      { label: "Accueil", to: "/", icon: "Home" },
      { label: "Catégories", to: "/categories", icon: "LayoutGrid" },
      { label: "Dates", hash: "dates", icon: "CalendarDays" },
      { label: "Jury", hash: "jury", icon: "Users" },
      { label: "Candidater", to: "/candidater", icon: "Award" },
    ],
    menuTitle: "Menu",
    menuOpen: "Ouvrir le menu",
    menuClose: "Fermer le menu",
    skip: "Aller au contenu",
  },

  ui: {
    discover: "Découvrir",
    contactTeam: "Contacter l'équipe",
    beNotified: "Être prévenu",
    apply: "Candidater",
    edition: "ÉDITION 2027",
    seeAll: "Voir toutes les catégories",
    seeFinalists: "Voir la page Finalistes",
    seeWinners: "Voir la page Gagnants",
    nextDate: "Prochaine date",
    scrollHint: "Défiler",
    prev: "Précédent",
    next: "Suivant",
    soon: "Bientôt",
    index: "Sommaire",
    countdown: {
      label: "Ouverture des candidatures dans",
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes",
      seconds: "Secondes",
      open: "Les candidatures sont ouvertes.",
    },
    emptyProduct: { name: "Nom du produit", brand: "Marque", category: "Catégorie" },
    footer: { rights: "COSMETICA BEAUTY AWARDS 2027", credit: "Site réalisé par", agency: "SOURATI DIGITAL", agencyUrl: "https://sourati.digital/" },
    comingSoon: "Coming soon",
  },

  hero: {
    brand: "COSMETICA BEAUTY AWARDS",
    lines: ["COSMETICA", "BEAUTY AWARDS"],
    tagline: "CÉLÉBRONS L'EXCELLENCE BEAUTÉ",
    edition: "ÉDITION 2027",
    status: "Les candidatures seront bientôt ouvertes.",
    text: "Une distinction dédiée aux produits, aux marques et aux savoir-faire qui contribuent à façonner la beauté de demain.",
    imageAlt: "Flacon de parfum en verre posé sur un tissu sombre, éclairé en lumière douce",
  },

  marquee: ["CÉLÉBRONS L'EXCELLENCE BEAUTÉ", "COSMETICA BEAUTY AWARDS", "ÉDITION 2027"],

  essence: {
    id: "essence",
    eyebrow: "Les Awards",
    title: "L'ESSENCE DES AWARDS",
    paragraphs: [
      "Les COSMETICA BEAUTY AWARDS célèbrent les produits et les marques qui se distinguent par leur qualité, leur créativité, leur innovation et leur capacité à répondre aux évolutions du marché de la beauté.",
      "À travers une sélection de catégories couvrant les principaux univers de la beauté, les Awards offrent aux marques une plateforme pour présenter leurs produits, mettre en valeur leur savoir-faire et bénéficier du regard de professionnels du secteur.",
      "Pensés au cœur de l'écosystème COSMETICA AFRICA, les Awards réunissent marques, fabricants, experts, distributeurs, acheteurs et professionnels autour d'une même ambition : faire émerger les produits qui méritent d'être découverts, reconnus et mis en lumière.",
    ],
    imageAlt: "Flacons de soin alignés sur une étagère, lumière douce",
  },

  why: {
    id: "pourquoi",
    eyebrow: "Pourquoi participer",
    title: "POURQUOI PARTICIPER ?",
    intro:
      "Participer aux COSMETICA BEAUTY AWARDS, c'est offrir à votre produit une occasion de sortir du lot, de rencontrer de nouveaux regards et de faire reconnaître le travail qui se cache derrière sa création.",
    items: [
      { title: "ÉVALUATION PAR DES PROFESSIONNELS", text: "Votre produit est présenté à un jury composé de professionnels aux expertises complémentaires, issus de différents métiers de l'industrie de la beauté." },
      { title: "VISIBILITÉ ACCRUE", text: "Les finalistes et les lauréats sont mis à l'honneur sur le site des COSMETICA BEAUTY AWARDS ainsi que sur les réseaux sociaux de COSMETICA AFRICA, à travers des contenus dédiés à la sélection et aux gagnants." },
      { title: "DÉCOUVERTE PAR L'ÉCOSYSTÈME BEAUTÉ", text: "Votre produit rejoint un environnement professionnel réunissant marques, fabricants, distributeurs, acheteurs et experts de l'industrie, au sein de l'écosystème COSMETICA." },
      { title: "PRÉSENCE DANS LA GALERIE DES AWARDS", text: "Les produits finalistes intègrent la sélection officielle des COSMETICA BEAUTY AWARDS et seront présentés dans un espace dédié pendant les quatre jours de COSMEORAN 2027, puis de COSMETICA AFRICA 2028. Cela offre aux produits gagnants une présence physique auprès des visiteurs des deux événements." },
      { title: "UNE DISTINCTION OFFICIELLE", text: "Les finalistes et les gagnants disposent d'éléments de communication officiels permettant de valoriser leur distinction." },
      { title: "UNE RECONNAISSANCE QUI VA PLUS LOIN", text: "Une sélection ou une victoire peut enrichir votre communication, votre storytelling produit, vos relations presse et vos échanges avec vos partenaires, distributeurs et acheteurs." },
    ],
  },

  who: {
    id: "participer",
    eyebrow: "Éligibilité",
    title: "QUI PEUT PARTICIPER ?",
    intro: "Les COSMETICA BEAUTY AWARDS s'adressent aux acteurs de la beauté qui souhaitent faire reconnaître leurs produits et leur savoir-faire.",
    listTitle: "PEUVENT NOTAMMENT PARTICIPER",
    list: [
      "Marques de beauté",
      "Fabricants et laboratoires cosmétiques",
      "Marques de soins de la peau",
      "Marques de soins capillaires",
      "Marques de maquillage",
      "Marques de parfumerie",
      "Marques de soins corporels",
      "Marques d'hygiène et de soins personnels",
      "Marques de beauté professionnelle",
      "Marques émergentes",
      "Marques établies",
      "Entreprises locales et internationales",
    ],
    note: "Les conditions d'éligibilité peuvent varier selon les catégories.",
    faq: [
      {
        q: "Une marque peut-elle participer sans être exposante à COSMETICA AFRICA ?",
        a: "Oui, sous réserve des conditions officielles de participation. Les COSMETICA BEAUTY AWARDS sont conçus pour réunir un large éventail d'acteurs de l'industrie et faire découvrir des produits issus de différents marchés.",
      },
    ],
    nb: "NB : Les critères définitifs d'éligibilité, les périodes de lancement et les conditions de participation sont précisés dans le règlement officiel des Awards.",
  },

  categories: {
    id: "categories",
    eyebrow: "Édition 2027",
    title: "LES CATÉGORIES 2027",
    pageIntro: "15 catégories",
    items: [
      { n: "01", title: "BEST SKINCARE PRODUCT", text: "Un produit de soin qui se distingue par sa formulation, ses performances, son expérience d'utilisation et sa réponse aux besoins actuels de la peau." },
      { n: "02", title: "BEST HAIRCARE PRODUCT", text: "Un produit de soin, de traitement ou de coiffage apportant une réponse efficace et adaptée aux besoins du cheveu et du cuir chevelu." },
      { n: "03", title: "BEST MAKEUP PRODUCT", text: "Un produit de maquillage remarquable par sa qualité, son rendu, sa tenue, sa formulation et son expérience d'utilisation." },
      { n: "04", title: "BEST FRAGRANCE", text: "Une fragrance portée par une identité olfactive distinctive, une composition de qualité et un univers cohérent." },
      { n: "05", title: "BEST BODY CARE PRODUCT", text: "Un produit dédié au soin et au bien-être du corps, associant efficacité, qualité de formulation et expérience sensorielle." },
      { n: "06", title: "BEST PERSONAL CARE PRODUCT", text: "Un produit de soin ou d'hygiène personnelle répondant de manière pertinente aux usages et aux attentes des consommateurs." },
      { n: "07", title: "BEST MEN'S GROOMING PRODUCT", text: "Un produit dédié aux soins masculins et à l'entretien du visage, du corps ou de la barbe, combinant efficacité, qualité et praticité au quotidien." },
      { n: "08", title: "BEST PROFESSIONAL BEAUTY PRODUCT", text: "Un produit conçu pour les professionnels de la beauté, répondant à leurs besoins spécifiques et aux exigences de leur pratique." },
      { n: "09", title: "BEST NATURAL & BOTANICAL PRODUCT", text: "Un produit fondé sur l'utilisation d'ingrédients d'origine naturelle ou botanique, avec une formulation cohérente et une approche clairement définie." },
      { n: "10", title: "BEAUTY INNOVATION AWARD", text: "Une innovation qui apporte une approche, une technologie ou une application nouvelle, et répond de manière originale à un besoin du secteur." },
      { n: "11", title: "BEST PACKAGING DESIGN", text: "Un packaging associant esthétique, fonctionnalité, créativité et cohérence avec l'identité du produit." },
      { n: "12", title: "BEST SUSTAINABLE BEAUTY PRODUCT", text: "Un produit intégrant une démarche responsable à travers sa formulation, ses matériaux, son packaging, sa conception ou son cycle de vie." },
      { n: "13", title: "BEST NEW PRODUCT LAUNCH", text: "Un lancement récent porté par un concept distinctif, un positionnement clair et une proposition adaptée au marché." },
      { n: "14", title: "MADE IN ALGERIA BEAUTY AWARD", text: "Un produit conçu et développé en Algérie, reflétant la qualité, la créativité et le savoir-faire de l'industrie algérienne de la beauté." },
    ],
    grandPrix: {
      n: "15",
      label: "GRAND PRIX",
      title: "COSMETICA BEAUTY PRODUCT OF THE YEAR",
      text: "Le titre phare de l'édition, le Grand Prix des COSMETICA BEAUTY AWARDS, est décerné au produit présentant l'excellence globale la plus remarquable à travers sa qualité, son concept, son exécution et sa pertinence.",
      imageAlt: "Flacon de parfum sur un tissu clair, lumière dorée",
    },
    nb: "NB : Les catégories, intitulés, critères d'éligibilité et éventuels changements de catégories seront précisés dans le règlement officiel de l'édition 2027.",
  },

  journey: {
    id: "parcours",
    eyebrow: "Le parcours",
    title: "LE PARCOURS VERS LES COSMETICA BEAUTY AWARDS",
    steps: [
      { n: "01", title: "CANDIDATEZ", text: "Sélectionnez votre catégorie et complétez votre dossier de participation avec les informations demandées." },
      { n: "02", title: "VÉRIFICATION DE L'ÉLIGIBILITÉ", text: "Chaque candidature est vérifiée au regard des conditions applicables à la catégorie choisie." },
      { n: "03", title: "SOUMISSION DU PRODUIT", text: "Les candidats éligibles transmettent les échantillons et les éléments requis pour l'évaluation." },
      { n: "04", title: "ÉVALUATION", text: "Les produits sont étudiés selon les critères définis pour leur catégorie par les membres du jury." },
      { n: "05", title: "FINALISTES", text: "Les produits sélectionnés pour la finale sont officiellement annoncés et mis en avant à travers les plateformes des Awards." },
      { n: "06", title: "ÉVALUATION FINALE", text: "Les finalistes font l'objet de l'évaluation finale selon la méthodologie applicable à leur catégorie." },
      { n: "07", title: "CÉRÉMONIE", text: "Les gagnants sont dévoilés lors de la cérémonie officielle des COSMETICA BEAUTY AWARDS 2027." },
    ],
  },

  dates: {
    id: "dates",
    eyebrow: "Calendrier",
    title: "LES DATES CLÉS",
    // `end` (ISO) sert uniquement à repérer automatiquement la prochaine date à venir.
    items: [
      { date: "30 OCTOBRE 2026", end: "2026-10-30", title: "ANNONCE DES AWARDS", text: "Présentation officielle de l'édition 2027 et ouverture de la communication." },
      { date: "10 NOVEMBRE 2026", end: "2026-11-10", title: "OUVERTURE DES CANDIDATURES", text: "Les marques peuvent commencer à soumettre leurs produits." },
      { date: "15 JANVIER 2027", end: "2027-01-15", title: "CLÔTURE DES CANDIDATURES", text: "Dernier délai pour soumettre une candidature." },
      { date: "31 JANVIER 2027", end: "2027-01-31", title: "DATE LIMITE DE RÉCEPTION DES ÉCHANTILLONS", text: "Les produits requis doivent avoir été transmis dans les délais indiqués." },
      { date: "FÉVRIER - DÉBUT MARS 2027", end: "2027-03-10", title: "PREMIÈRE PHASE D'ÉVALUATION", text: "Les membres du jury évaluent les candidatures selon les critères définis." },
      { date: "15 MARS 2027", end: "2027-03-15", title: "ANNONCE DES FINALISTES", text: "Les produits sélectionnés accèdent à la finale." },
      { date: "MARS - DÉBUT AVRIL 2027", end: "2027-04-10", title: "ÉVALUATION FINALE", text: "Dernière étape avant la sélection des gagnants." },
      { date: "FIN AVRIL 2027", end: "2027-04-30", title: "CÉRÉMONIE DES AWARDS", text: "Dévoilement des gagnants et célébration de l'excellence beauté." },
    ],
    nb: "NB : Dates à confirmer dans le calendrier officiel de l'édition 2027.",
  },

  jury: {
    id: "jury",
    eyebrow: "Le jury",
    title: "LE JURY",
    intro: [
      "La crédibilité d'un Award repose sur la qualité des regards qui évaluent les produits.",
      "Les COSMETICA BEAUTY AWARDS réuniront un jury pluridisciplinaire de professionnels issus de différents univers de la beauté et de disciplines complémentaires.",
    ],
    profilesTitle: "Selon les catégories, le jury pourra réunir des profils issus notamment de :",
    profiles: [
      "La formulation et la recherche",
      "Le développement produit",
      "La cosmétique et la parfumerie",
      "La beauté professionnelle",
      "Le retail et la distribution",
      "Le marketing et le branding",
      "Le packaging et le design",
      "L'innovation et les technologies",
      "Les médias et l'expertise beauté",
    ],
    outro: "Cette diversité de perspectives permet d'appréhender les produits sous plusieurs angles et de prendre en compte aussi bien leurs qualités intrinsèques que leur pertinence dans leur environnement de marché.",
    banner: "Composition du jury bientôt annoncée",
    portraitSlots: 8,
    members: [], // { name, role, photo } — à renseigner à l'annonce du jury
    nb: "NB : La composition définitive du jury sera annoncée officiellement par les canaux de communication de COSMETICA BEAUTY AWARDS.",
  },

  criteria: {
    id: "criteres",
    eyebrow: "Évaluation",
    title: "LES CRITÈRES D'ÉVALUATION",
    intro: "Chaque catégorie possède ses propres spécificités. L'évaluation peut notamment prendre en compte plusieurs dimensions du produit.",
    items: [
      { icon: "Gauge", title: "EFFICACITÉ ET PERFORMANCE", text: "Qualité et pertinence des performances du produit au regard de sa catégorie." },
      { icon: "Sparkles", title: "INNOVATION ET ORIGINALITÉ", text: "Originalité du concept, de l'approche, de la formulation, de la technologie ou de l'application." },
      { icon: "FlaskConical", title: "FORMULATION ET TECHNOLOGIE", text: "Qualité et maîtrise de la formulation, pertinence des ingrédients, ainsi que la performance des technologies et des systèmes de délivrance associés au produit." },
      { icon: "Hand", title: "EXPÉRIENCE UTILISATEUR", text: "Texture, sensorialité, facilité d'utilisation, praticité et expérience globale selon la nature du produit." },
      { icon: "Package", title: "PACKAGING ET DESIGN", text: "Fonctionnalité, ergonomie, identité visuelle, cohérence esthétique et qualité d'exécution." },
      { icon: "BookOpen", title: "CONCEPT ET STORYTELLING", text: "Clarté du positionnement, cohérence de l'identité et capacité à construire un récit distinctif et cohérent." },
      { icon: "Target", title: "PERTINENCE MARCHÉ", text: "Adéquation avec les attentes des consommateurs, les usages et les évolutions du secteur." },
      { icon: "Leaf", title: "RESPONSABILITÉ", text: "Prise en compte des dimensions environnementales, éthiques ou responsables lorsque celles-ci sont pertinentes pour la catégorie." },
    ],
    nb: "NB : Les critères et leur pondération peuvent varier selon les catégories et seront détaillés dans le règlement et dans la méthodologie officielle.",
  },

  finalists: {
    id: "finalistes",
    eyebrow: "La sélection",
    title: "ÊTRE FINALISTE, C'EST DÉJÀ ÊTRE RECONNU",
    status: "Annonce prévue le 15 mars 2027",
    intro: "Atteindre la finale des COSMETICA BEAUTY AWARDS signifie que votre produit a été retenu parmi les candidatures évaluées dans sa catégorie.",
    listTitle: "CE QUE LES FINALISTES PEUVENT RECEVOIR",
    items: [
      { title: "STATUT OFFICIEL DE FINALISTE", text: "Une reconnaissance officielle de votre sélection pour l'édition 2027." },
      { title: "VISUELS PROPRES AUX FINALISTES", text: "Des éléments graphiques dédiés pour communiquer autour de votre sélection." },
      { title: "VISIBILITÉ DIGITALE", text: "Mise en avant sur les plateformes de communication des COSMETICA BEAUTY AWARDS." },
      { title: "PRÉSENCE SUR LE SITE OFFICIEL", text: "Présentation du produit dans la sélection officielle des finalistes." },
      { title: "AWARDS GALLERY", text: "Intégration du produit dans la galerie officielle des Awards." },
      { title: "PRÉSENCE À LA CÉRÉMONIE", text: "Invitation à la cérémonie officielle des COSMETICA BEAUTY AWARDS, selon les modalités définies par l'organisation." },
    ],
    products: [], // { image, name, brand, category } — grille prête à recevoir les produits
    imageAlt: "Flacons de soin sur une surface sombre, éclairage de studio",
  },

  winners: {
    id: "gagnants",
    eyebrow: "Les lauréats",
    title: "LES GAGNANTS",
    status: "Dévoilés fin avril 2027",
    intro: "Une victoire aux COSMETICA BEAUTY AWARDS offre à un produit une reconnaissance officielle au sein d'un écosystème professionnel dédié à la beauté.",
    listTitle: "LES GAGNANTS PEUVENT BÉNÉFICIER DE",
    items: [
      { title: "TROPHÉE OFFICIEL", text: "Une distinction physique célébrant la victoire." },
      { title: "CERTIFICAT WINNER", text: "Une reconnaissance officielle de la victoire dans la catégorie concernée." },
      { title: "WINNER MARK", text: "Un élément de distinction destiné à la communication du gagnant, selon les règles d'utilisation officielles." },
      { title: "COMMUNICATION DIGITALE", text: "Annonce et mise en avant des gagnants sur les plateformes des Awards." },
      { title: "PRÉSENCE SUR LE SITE OFFICIEL", text: "Présentation du produit gagnant dans la sélection officielle des lauréats." },
      { title: "CONTENU ÉDITORIAL", text: "Possibilités de mise en avant à travers les contenus consacrés aux gagnants." },
      { title: "PHOTOGRAPHIES ET CONTENU AWARDS", text: "Valorisation du produit et de sa distinction dans les contenus officiels, selon les dispositifs prévus." },
      { title: "VISIBILITÉ AU SEIN DE L'ÉCOSYSTÈME COSMETICA", text: "Une reconnaissance pouvant être valorisée dans les communications de la marque auprès de ses partenaires, distributeurs, acheteurs et professionnels." },
    ],
    products: [],
    nb: "NB : L'utilisation du Winner Mark sur les produits, emballages et supports commerciaux est soumise aux conditions et aux règles d'utilisation officielles des COSMETICA BEAUTY AWARDS ainsi qu'aux réglementations applicables.",
  },

  ecosystem: {
    id: "ecosysteme",
    eyebrow: "Écosystème",
    title: "AU CŒUR DE L'ÉCOSYSTÈME DE COSMETICA",
    intro: "Les COSMETICA BEAUTY AWARDS s'inscrivent dans un écosystème professionnel dédié au développement de l'industrie de la beauté en Afrique.",
    items: [
      { icon: "Landmark", title: "COSMETICA AFRICA", text: "Un rendez-vous professionnel réunissant marques, fabricants, fournisseurs, distributeurs, acheteurs et professionnels de la beauté." },
      { icon: "Handshake", title: "COSMETICA CONNECT", text: "Un programme dédié aux rencontres B2B et à la mise en relation avec des décideurs et acheteurs qualifiés." },
      { icon: "ShoppingBag", title: "ACHETEURS ET CONSOMMATEURS", text: "Des professionnels à la recherche de produits, de marques et de nouvelles opportunités commerciales." },
      { icon: "Truck", title: "DISTRIBUTEURS", text: "Des acteurs à la recherche de nouvelles marques et de produits à intégrer à leurs marchés." },
      { icon: "Users", title: "PROFESSIONNELS DE L'INDUSTRIE", text: "Des experts et professionnels issus de différents segments de l'industrie de la beauté." },
    ],
    outro: "Les COSMETICA BEAUTY AWARDS prolongent ainsi la vocation de COSMETICA AFRICA : créer des connexions entre les produits, les professionnels et les marchés.",
  },

  finalCall: {
    id: "contact",
    title: "COSMETICA BEAUTY AWARDS 2027",
    tagline: "CÉLÉBRONS L'EXCELLENCE BEAUTÉ",
    keyDatesTitle: "DATES CLÉS",
    keyDates: [
      { label: "Ouverture des candidatures", value: "10 novembre 2026" },
      { label: "Date limite de candidature", value: "15 janvier 2027" },
    ],
    applyOn: "Candidatez sur",
    teamTitle: "Awards Team",
    // Coordonnées modifiables : laisser vide ("") pour masquer la ligne.
    team: { email: "", phone: "", other: "" },
    teamLabels: { email: "E-mail", phone: "Téléphone", other: "Autre" },
    teamPending: "Coordonnées à renseigner",
  },

  contactPage: {
    eyebrow: "Contact",
    title: "CONTACTER L'ÉQUIPE",
  },

  applyPage: {
    eyebrow: "ÉDITION 2027",
    closedTitle: "Les candidatures seront bientôt ouvertes",
    closedText: "Ouverture des candidatures : 10 novembre 2026.",
    openTitle: "Les candidatures sont ouvertes",
    openText: "Candidatez sur awards.cosmeticaafrica.com",
    openButton: "Candidater maintenant",
  },

  forms: {
    notify: {
      title: "Être prévenu de l'ouverture",
      email: "Adresse e-mail",
      brand: "Nom de la marque (facultatif)",
      submit: "Être prévenu",
      sending: "Envoi…",
      success: "Merci. Votre adresse est bien enregistrée : vous serez prévenu de l'ouverture des candidatures.",
    },
    contact: {
      title: "Contacter l'équipe",
      name: "Nom",
      email: "Adresse e-mail",
      phone: "Téléphone",
      brand: "Marque",
      message: "Message",
      submit: "Envoyer",
      sending: "Envoi…",
      success: "Merci. Votre message a bien été envoyé. L'équipe vous répondra prochainement.",
    },
    errors: {
      required: "Ce champ est requis.",
      email: "Adresse e-mail invalide.",
      server: "Une erreur est survenue. Merci de réessayer.",
    },
  },

  pages: {
    categories: { eyebrow: "Édition 2027", title: "LES CATÉGORIES 2027" },
    finalists: { eyebrow: "Sélection officielle", title: "FINALISTES" },
    winners: { eyebrow: "Édition 2027", title: "GAGNANTS" },
  },

  notFound: { title: "Page introuvable", back: "Retour à l'accueil" },
};

export default content;
